import { AxiosInstance } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export const requestSavePersonalDetails = (data: any) : Promise<AxiosInstance> => axios.request({
  method: 'post',
  baseURL: endPoints.base,
  url: endPoints.savePersonalDetails,
  data,
});

export default {};
